export enum SocialProvider {
  GOOGLE = 'google',
  MICROSOFT = 'microsoft',
}

export const SOCIAL_PROVIDERS: SocialProvider[] = Object.values(SocialProvider);

export const isSocialProvider = (value: string): value is SocialProvider =>
  SOCIAL_PROVIDERS.some((provider) => provider === value);
